export default __webpack_public_path__ + "823f98f8238a82c0e98f6f853e0ded67.png";